import { useTranslation } from "@/core/i18n";
import { cn } from "@/lib/utils";
import { Icon } from "atoms/icon/Icon";
import AiStartIcon from "atoms/icon/icons/ai-start-icon.svg";

interface JustForYouTagProps {
  variant?: "in-carousel-card" | "shop";
}

export const JustForYouTag = (props: JustForYouTagProps) => {
  const { t } = useTranslation();
  const { variant = "shop" } = props;

  const variantClasses = variant === "in-carousel-card" ? "rounded-lg m-auto" : "rounded";

  const computedClassNameList = cn(
    variantClasses,
    "inline-flex w-fit items-center gap-[5px] bg-[rgba(222,193,156,0.6)] px-[6px]",
  );

  return (
    <div className={computedClassNameList}>
      <Icon svg={AiStartIcon} className="-mt-[1px]" size="x3small" color="primaryText" />
      <span className="py-1 text-chip font-[700] uppercase tracking-[0.4px] text-black">
        {t("justForYouTag.label")}
      </span>
    </div>
  );
};
